import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ty from "../Assets/newty.jpg";
import { Link, } from "react-router-dom";


function NormalThankYou() {


  return (
    <>
      <Navbar />
      <div className="thanqq">
        <p>
          <img src={ty} alt="Thank You" />
          {/* Lorem Ipsum is simply dummy text of the printing and typesetting
       industry. */}
        </p>

        <br />
        <Link to="/profile">
          <button>View Subscription</button>
        </Link>
      </div>
      <Footer />
    </>
  );
}

export default NormalThankYou;
